// extracted by mini-css-extract-plugin
export default {"error":"MainError_error__cqjd2","errorIcon":"MainError_errorIcon__ZIaEq","errorTitle":"MainError_errorTitle__pcXdv","errorSubtitle":"MainError_errorSubtitle__3fZN1"};